module.exports = __webpack_public_path__ + "static/media/f3.b3e0704d.png";